<template lang="pug">
k-field-wrapper(
  v-bind="$props"
  :label="topLabel ? labelI18n : false"
)
  v-textarea(
    v-bind="$data.$_attrs"
    v-on=`{
      ...$data.$_listeners,
      blur: onBlur,
      click: handleInputClick,
      change: () => displayErrors = true
    }`
    solo
    :rows="sizedRows"
    ref="field"
    :label="topLabel ? '' : labelI18n"
    :placeholder="topLabel ? placeholderI18n : labelI18n"
    :value="value"
    :counter="counter"
    :maxlength="maxlength"
    :hint="(sideHint || topHint) ? '' : hintI18n"
    :error="hasVisibleError"
    :error-messages="visibleInlineErrorMessages"
    :class="fieldClasses"
  ).v-textarea--solo
    template(slot="label").uppercase.font-weight-bold {{ label }}
    template(#append)
      slot(name="append")
    template(#prepend-inner)
      slot(name="prepend-inner")
</template>

<script>
import { IsField, BindsAttrs } from '@/mixins'

export default {
  mixins: [
    IsField,
    BindsAttrs
  ],
  props: {
    rows: {
      type: [ Number, String ],
      default: 0,
    },
  },
  computed: {
    sizedRows () {
      if (parseInt(this.rows) > 0) {
        return this.rows
      }
      if (this.small) {
        return 1
      }
      if (this.large) {
        return 6
      }
      return 2
    },
  }
}
</script>

<style lang="scss" scoped>
.k-field-textarea {
  position: relative;


  /* Hacky vuetify styling */
  ::v-deep {
    /* Set font sizes */
    textarea {
      @extend %paragraph;

      &::placeholder {
        color: var(--v-brand-warm-grey-base)
      }
    }

    /* General Medium Sizing */
    .v-input__control {
      min-height: 0;
    }

    .v-input__slot {
      padding: 0 !important;

      label {
        @extend %paragraph;
      }
    }

    .v-text-field__slot {
      margin: 0 !important;

      textarea {
        @extend %paragraph;
        margin-top: 0 !important;
        padding: 15px 18px !important;
      }
    }

    /* Add right padding and flex styling to anything prepend in text box */
    .v-input__prepend-inner,
    .v-input__append-inner {
      align-items: center;
      display: flex;
      height: 100%;
    }

    .v-input__prepend-inner {
      padding-left: 12px;
      padding-right: 0;
    }

    .v-counter {
      color: var(--v-brand-warm-grey-base);
      opacity: 0;
      padding-top: 5px;
      transition: .2s;
    }

    /* ensure inner icons are centered */
    .v-input__prepend-inner,
    .v-input__append-inner {
      margin: auto 0 !important;
    }

    /* add border and box shadow */
    .v-input__slot {
      border: 2px solid var(--v-brand-warm-grey-base);
      border-radius: 4px !important;
      box-shadow: inset 6px 6px 3px rgba(48, 50, 75, .05) !important;
      margin-bottom: 0 !important;
      transition: .2s;
    }
  }


  /* Style changes when focused */
  &.v-input--is-focused {
    ::v-deep {
      .k-field-textarea__counter {
        opacity: 1 !important;
      }

      .v-counter {
        opacity: 1;
      }

      .v-input__slot {
        border: 2px solid var(--v-brand-dark-blue-base) !important;
        box-shadow: 0 0 6px var(--v-brand-dark-blue-base) !important;
      }

      .v-icon {
        color: var(--v-brand-pink-base);
      }
    }
  }

  /* Disabled styling */
  &.v-input--is-disabled {
    ::v-deep {
      .v-input__slot {
        background-color: var(--v-brand-grey-10-base) !important;
        border: 0 !important;
        box-shadow: inset 6px 6px 3px rgba(48, 50, 75, .02) !important;
      }
    }
  }

  /* Error messages */
  &.error--text {
    ::v-deep {
      .v-input__slot {
        border: 2px solid var(--v-error-base) !important;
      }
    }
  }

  &__counter {
    @extend %paragraph--small;
    bottom: 10px;
    color: var(--v-brand-warm-grey-base);
    opacity: 0;
    position: absolute;
    right: 15px;
    transition: .2s;
  }

  /* Large size changes */
  &--large {
    ::v-deep {
      .v-input__slot {
        label {
          @extend %paragraph--large;
        }
      }

      .v-text-field__slot {
        textarea {
          padding: 24px 26px !important;
          @extend %paragraph--large;
        }
      }
    }
  }

  /* Small size changes */
  &--small {
    ::v-deep {
      .v-input__slot {
        label {
          @extend %paragraph--small;
        }
      }

      .v-text-field__slot {
        textarea {
          padding: 9px 12px !important;
          @extend %paragraph--small;
        }
      }
    }
  }
}

</style>
